let _rules = [
    {name: "sex", checkType: "required", errorMsg: "性别不能为空"},
    {name: "idCard", checkType: "idCard", errorMsg: "身份证号格式不对"},
    {name: "birthday", checkType: "ymd", errorMsg: "出生年月日期格式不合适"}
];

export {
    _rules
}